import React, { useState } from 'react';

export const SearchFormContext = React.createContext();

export const SearchFormProvider = ({ children }) => {
  const [isEditedManuField, setIsEditedManuField] = useState(false);
  const [isEditedCarField, setIsEditedCarField] = useState(false);
  const [isEditedModelField, setIsEditedModelField] = useState(false);
  const [isEditedVinVehicleField, setIsEditedVinVehicleField] = useState(false);
  const [isEditedPartField, setIsEditedPartField] = useState(false);
  const [isErrorCar, setIsErrorCar] = useState(false);
  const [isErrorPart, setIsErrorPart] = useState(false);
  const [isErrorManu, setIsErrorManu] = useState(false);
  const [isErrorModel, setIsErrorModel] = useState(false);
  const [isErrorVinVehicle, setIsErrorVinVehicle] = useState(false);
  const [isSelectedCar, setIsSelectedCar] = useState(false);
  const [isSelectedManu, setIsSelectedManu] = useState(false);
  const [isSelectedModel, setIsSelectedModel] = useState(false);
  const [isSelectedVin, setIsSelectedVin] = useState(false);
  const [isSelectedVinVehicle, setIsSelectedVinVehicle] = useState(false);
  const [isSelectedPart, setIsSelectedPart] = useState(false);
  const [isCarTooltip, setIsCarTooltip] = useState(false);
  const [isManuTooltip, setIsManuTooltip] = useState(false);
  const [isModelTooltip, setIsModelTooltip] = useState(false);
  const [isVinVehicleTooltip, setIsVinVehicleTooltip] = useState(false);
  const [isPartTooltip, setIsPartTooltip] = useState(false);

  return (
    <SearchFormContext.Provider
      value={{
        isEditedManuField,
        setIsEditedManuField,
        isEditedCarField,
        setIsEditedCarField,
        isEditedModelField,
        setIsEditedModelField,
        isEditedPartField,
        setIsEditedPartField,
        isEditedVinVehicleField,
        setIsEditedVinVehicleField,
        isErrorCar,
        setIsErrorCar,
        isErrorPart,
        setIsErrorPart,
        isErrorManu,
        setIsErrorManu,
        isErrorVinVehicle,
        setIsErrorVinVehicle,
        isErrorModel,
        setIsErrorModel,
        isSelectedCar,
        setIsSelectedCar,
        isSelectedManu,
        setIsSelectedManu,
        isSelectedModel,
        setIsSelectedModel,
        isSelectedVin,
        setIsSelectedVin,
        isSelectedVinVehicle,
        setIsSelectedVinVehicle,
        isSelectedPart,
        setIsSelectedPart,
        isCarTooltip,
        setIsCarTooltip,
        isManuTooltip,
        setIsManuTooltip,
        isModelTooltip,
        setIsModelTooltip,
        isPartTooltip,
        setIsPartTooltip,
        isVinVehicleTooltip,
        setIsVinVehicleTooltip,
      }}
    >
      {children}
    </SearchFormContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/context/SearchFormContext.js